import { combineReducers } from 'redux';
import { paymentPlanReducer } from './paymentPlanReducer';
import { beneficiaryReducer } from './beneficiaryReducer';
import { loanReducer } from './loanReducer';
import { IAppState } from '../store';
import { dashboardReducer } from './dashboardReducer';
import { userReducer } from './userReducer';
import submissionReducer from './submissionReducers';
import loanApplicationReducer from './loanApplicationReducers';
import flashMessageReducer from './flashMessageReducer';
import repaymentReducer from './repaymentReducer';
import { disbursementPayoutReducer } from './disbursementPayoutReducer';
import { borrowerReducer } from './borrowerProfileReducer';

const rootReducer = combineReducers<IAppState>({
  userState: userReducer,
  dashboardState: dashboardReducer,
  submissionState: submissionReducer,
  loanApplicationState: loanApplicationReducer,
  flashMessageState: flashMessageReducer,
  repaymentState: repaymentReducer,
  disbursementPayoutState: disbursementPayoutReducer,
  borrowerProfileState: borrowerReducer,
  loanState: loanReducer,
  beneficiaryState: beneficiaryReducer,
  paymentPlanState: paymentPlanReducer,
});

export default rootReducer;
